import { render, staticRenderFns } from "./UserPropDetailPanel.vue?vue&type=template&id=24282780&scoped=true"
import script from "./UserPropDetailPanel.vue?vue&type=script&lang=js"
export * from "./UserPropDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPropDetailPanel.vue?vue&type=style&index=0&id=24282780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24282780",
  null
  
)

export default component.exports